import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Collapse } from 'reactstrap';
import { snakeCaseToTitleCase } from '../../common/utils/api_utils';

const videoCategories = [
  { label: 'Builder Basics', value: 'BUILDER_BASICS' },
  { label: 'Elements', value: 'ELEMENTS' },
  { label: 'Designing & Layout', value: 'DESIGNING_AND_LAYOUT' },
  {
    label: 'Advance UI Component',
    value: 'ADVANCE_UI_COMPONENT',
  },
  {
    label: 'Collection & Dynamic Content',
    value: 'COLLECTION_AND_DYNAMIC_CONTENT',
  },
  { label: 'E-Commerce', value: 'E_COMMERCE' },
  { label: 'Hosting & Code Export', value: 'HOSTING_AND_CODE_EXPORT' },
  { label: 'Seo', value: 'SEO' },
  { label: 'Template', value: 'TEMPLATE' },
  { label: 'Project Settings', value: 'PROJECT_SETTINGS' },
  { label: 'Accounting & Billing', value: 'ACCOUNTING_AND_BILLING' },
];
export class DefaultPage extends Component {
  static propTypes = {
    tutorial: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    currentVideoId: 'KXqrIYnCRSY',
    activeCategory: '',
  };

  activateCategory = (name) => {
    if (this.state.activeCategory === name) {
      this.setState({ activeCategory: '' });
    } else {
      this.setState({ activeCategory: name });
    }
  };

  showCard = () => {
    return {
      display: !this.props.tutorial.toggleTutorialModal ? 'none' : '',
    };
  };

  closeCard = () => {
    this.props.actions.toggleTutorialModal();
  };

  componentDidMount = () => {
    this.props.actions.loadAllVideos();
  };

  changeVideoId = (url) => {
    const videoId = url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
    if (videoId && videoId[2]) {
      this.setState({ currentVideoId: videoId[2] });
    }
  };

  getCategoryName = (val) => {
    let category = videoCategories.find((e) => e.value === val);
    return category ? category.label : val;
  };

  render() {
    const { videoListWithCategory, toggleTutorialModal } = this.props.tutorial;
    const { activeCategory, currentVideoId } = this.state;
    return (
      <div className="gjs-mdl-container" style={this.showCard()}>
        <div
          className="gjs-mdl-dialog gjs-one-bg gjs-two-color"
          style={{ maxWidth: '90%', marginLeft: '7em' }}
        >
          <div className="gjs-mdl-header">
            <div className="gjs-mdl-title">Tutorials</div>
            <div className="gjs-mdl-btn-close" onClick={this.closeCard}>
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">
              <div className="row">
                <div className="col-9">
                  {toggleTutorialModal ? (
                    <iframe
                      width="100%"
                      height="590vh"
                      src={`https://www.youtube.com/embed/${currentVideoId}`}
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    ''
                  )}
                </div>
                <div
                  className="col-3"
                  style={{ fontSize: '0.9rem', paddingLeft: '0', paddingRight: '5px' }}
                >
                  <div
                    className="col-12 video-modal-scroll"
                    style={{ paddingLeft: '0', paddingRight: '5px' }}
                  >
                    {Object.keys(videoListWithCategory).map((category) => (
                      <Fragment key={category}>
                        <div
                          className="collection-list p-1"
                          onClick={() => this.activateCategory(category)}
                        >
                          {this.getCategoryName(category)}
                        </div>
                        <Collapse isOpen={activeCategory === category}>
                          <ul style={{ paddingLeft: '10px' }}>
                            {videoListWithCategory[category].map((e) => (
                              <li
                                key={e.uuid}
                                style={{ listStyle: 'none', cursor: 'pointer' }}
                                onClick={() => {
                                  this.changeVideoId(e.youtubeUrl);
                                }}
                                className="mt-2"
                              >
                                <i className="wb webconnect-youtube"></i> {e.title}
                              </li>
                            ))}
                          </ul>
                        </Collapse>
                      </Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tutorial: state.tutorial,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
